import SessionClient, { StatusFlags } from "util/SessionClient";
import { UserSubscriptionStatusEnum } from "rdx/modules/users/enums";

type SessionUtilsT = {
  session: SessionClient;
  paymentStatusFlags: StatusFlags | null;
  enrollmentStatus: UserSubscriptionStatusEnum;
};

const session = new SessionClient();

export function useSession(): SessionUtilsT {
  return {
    session,
    paymentStatusFlags: session.statusFlags,
    enrollmentStatus: session.enrollmentStatus,
  };
}
